"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseKVStore = void 0;
class BaseKVStore {
    constructor(provider, _prefix) {
        this.provider = provider;
        this._prefix = _prefix;
    }
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const k = this.prefix() + "/" + key;
            const data = yield this.provider.get();
            return data[k];
        });
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        return this.provider.set({ [k]: data });
    }
    prefix() {
        return this._prefix;
    }
}
exports.BaseKVStore = BaseKVStore;
//# sourceMappingURL=base.js.map